import Modal from '@material-ui/core/Modal';
import { useStyles } from './SelectTTIModal.styles.js';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ReactTimeAgo from 'react-time-ago';

import { ButtonGroup, Button } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CircularProgress from '@material-ui/core/CircularProgress';

import { fetchTTITrainings } from '../../services/page.services.js';

import coverImg from '../../img/cover.png';
import { showMessageV2 } from '../../utils/page.utils.js';

export default function SelectTTIModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //modal
  const { open, loading } = props;

  const user = useSelector(state => state.user);
  const userId = user?.id;

  //initData
  const [data, setData] = useState([]);

  const [fontStyle, setFontStyle] = useState('TheJamsil');

  useEffect(() => {
    if (userId) initPage();
  }, [userId]);

  useEffect(() => {
    const defaultLanguage = localStorage.getItem('selectedLanguage') || navigator.language.split('-')[0];
    const defaultFont = defaultLanguage === 'ja' ? 'MPlus1' : 'TheJamsil';
    setFontStyle(defaultFont);
  }, []);

  const initPage = async () => {
    try {
      const trainings = await fetchTTITrainings();
      setData(trainings);
    } catch (e) {
      console.log(e);
      showMessageV2(dispatch, t('modal.pageLoadFail'), { reloadOnClose: true });
    }
  };

  const handleSelectModel = model => {
    props.onSelectModel(model);
  };

  return (
    <Modal
      open={!!open}
      onClose={() => {
        props.onSelectModelModalClose();
      }}
      disableEnforceFocus
      className={fontStyle}
    >
      <div id="scrollableDiv" className={classes.container}>
        {!loading && data && (
          <>
            <div className={classes.pageTitle}>{t('ttiInferenceTab.ttiCommunityTab.title')}</div>
            <div className={classes.separater} />

            <ButtonGroup className={classes.inputSourceButtonContainer}>
              <Button
                className={`${classes.inputSourceButton}`}
                style={{ fontSize: 'inherit' }}
                // onClick={() => setModelType('my voices')}
              >
                {t('ttiInferenceTab.ttiCommunityTab.categoryTab.0')}
              </Button>
            </ButtonGroup>

            <Grid container className={classes.cardGrid}>
              <div className={classes.selectModelButton} onClick={() => navigate('/tti-train-image')}>
                <AddCircleIcon className={classes.addButtonImg} />
                <div className={classes.dragAndDropText}>{t('ttiInferenceTab.ttiCommunityTab.createNewModel')}</div>
              </div>
              {data
                .filter(item => item.status === 'COMPLETE')
                .map(({ id, label, createdAt, usage, thumbnail }) => {
                  return (
                    <Grid
                      className={classes.card}
                      item
                      container
                      key={id}
                      onClick={() => handleSelectModel({ id, label, thumbnail, usage })}
                    >
                      <img src={thumbnail || coverImg} alt={label} className={classes.coverImg} />
                      <div className={classes.usageTag}>{t(`historyTab.tabs.ttiTraining.${usage}`)}</div>
                      <div className={classes.cardContent}>
                        <div className={classes.cardLabel}>{label}</div>
                        <div className={classes.cardTimestamp} style={{ marginBottom: '0.2rem' }}>
                          <ReactTimeAgo date={createdAt} />
                        </div>
                      </div>
                    </Grid>
                  );
                })}
            </Grid>
          </>
        )}
        {loading && <CircularProgress className={classes.loading} />}
      </div>
    </Modal>
  );
}
